import { css, keyframes } from "styled-components"

/* animation-name: example;
  animation-duration: 5s;
  animation-timing-function: linear;
  animation-delay: 2s;
  animation-iteration-count: infinite;
  animation-direction: alternate; */

/* div {
  animation: example 5s linear 2s infinite alternate;
} */

export const keyframeFloating = keyframes`
  0% { transform: translate(0,  0px); }
  50%  { transform: translate(0, -17px); }
  100%   { transform: translate(0, -0px); }
`

export const keyframePulsateBig = keyframes`
  0% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  50% {
    -webkit-transform: scale(1.2);
            transform: scale(1.2);
  }
  100% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
`

export const keyframePulsateSmall = keyframes`
  0% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  50% {
    -webkit-transform: scale(0.8);
            transform: scale(0.8);
  }
  100% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
`

const keyframeBounceFloat = (x, y) => keyframes`
   0%   {transform:translate3d(0,0,0)}
  100%  {transform:translate3d(${x * 2}px,${y * 2}px,0)}
`

export const bounceCss = (x, y) => css`
  position: relative;
  left: ${x * -1}px;
  top: ${y * -1}px;
  animation: ${keyframeBounceFloat(x, y)} 2.5s cubic-bezier(0.6, 0, 0.4, 1) 1s
    infinite alternate;
`
export const keyframeRotateInCenter = keyframes`
    0% {
      -webkit-transform: rotate(0);
              transform: rotate(0);
      opacity: 1;
    }
    60% {
      -webkit-transform: rotate(360deg);
              transform: rotate(360deg);
      opacity: 1;
    }
    100% {
      -webkit-transform: rotate(360deg);
              transform: rotate(360deg);
      opacity: 1;
    }
`
/* animation example: */
/* const StyledBasketAnimation = styled.div<{ $doAnimation: boolean }>`
  animation: ${(props) =>
    props.$doAnimation
      ? css`
          ${keyframePulsateSmall} 0.3s ease-in-out 1;
        `
      : ""};
` */
/* @-webkit-keyframes rotate-in-center {
    0% {
      -webkit-transform: rotate(-360deg);
              transform: rotate(-360deg);
      opacity: 0;
    }
    100% {
      -webkit-transform: rotate(0);
              transform: rotate(0);
      opacity: 1;
    }
  }
  @keyframes rotate-in-center {
    0% {
      -webkit-transform: rotate(-360deg);
              transform: rotate(-360deg);
      opacity: 0;
    }
    100% {
      -webkit-transform: rotate(0);
              transform: rotate(0);
      opacity: 1;
    }
  } */

export const keyframeSize = keyframes`
  from {
    width: 250px;
    height: 200px;
  }
  to {
    width: 150px;
    height: 60px;

  }
`

export const keyframeSizeOpacity = keyframes`
from {
  width: 250px;
  height: 200px;
  opacity: 0;
}
to {
  width: 150px;
  height: 60px;
  opacity: 0;
}
`

export const keyFrameSizeToBig = keyframes`
from {
  width: 0px;
  height: 0px;
}
to {
  width: 100%;
  height: 180px;
}

`

export const keyFrameOpacity = keyframes`
0% { opacity:0; }
100% { opacity:1; }
`

export const keyFrameFadeOut = keyframes`
0% { opacity:1; }
100% { opacity:0; }
`

export const keyFrameFadeIn = keyframes`
0% { opacity:0; }
100% { opacity:1; }
`

export const keyFrameCircle = keyframes`
  0% { opacity: 0.9;  width: 0; height: 0; }
  100% { opacity: 0.6; height: 300%; width: 300%; }
`

export const keyFrameCircleFull = keyframes`
  0% { opacity: 0.9;   height: 100%; width: 100%; }
  100% { opacity: 0.6; height: 100%; width: 100%; }
`
